import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

const RaceCourseList = ({ setRacecourse, racecourse }) => {
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");

  const [activeElement, setActiveElement] = useState("option1");

  const array = [
    { label: "MEYDAN RACECOURSE", labelAr: "مضمار ميدان", value: "option1" },
    { label: "ABU DHABI EQUESTRIAN", labelAr: "نادي أبوظبي للفروسية ", value: "option2" },
    { label: "JEBEL ALI RACECOURSE", labelAr: "مضمار جبل علي", value: "option3" },
    { label: "SHARJAH EQUESTRIAN", labelAr: "نادي الشارقة للفروسية والسباق", value: "option4" },
    { label: "AL AIN RACECOURSE", labelAr: "مضمار العين", value: "option5" },
  ];

  const handleItemClick = (value) => {
    setRacecourse(value);
    setActiveElement(value);
  };

  return (
    <>
        <h4>{t("RACECOURSES")}</h4>
        {array.map((elem) => (
            <div
              key={elem.value}
              onClick={() => handleItemClick(elem.value)}
              className={`new-slim-card ${activeElement === elem.value ? 'new-active' : ''}`}
            >
              {cookiedata === "en" ? elem.label : elem.labelAr}
            </div>
        ))}
    </>
  );
};

export default RaceCourseList;